// @flow
import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';
import handleReduce from '~/core/state/handle-reduce';
import { getProductIndexById } from '~/core/state/products/selectors';
import * as constants from './constants';
import * as types from './types';

const initialState = fromJS({
    hubOfflineNotifications: {
        status: false
    }
});

export const productReducers = {
    [constants.SET_DEFAULT_MUTING_DONE]: handleReduce((state, { payload: { productId, defaultMuting } }) => {
        const index = getProductIndexById(state, productId);

        return {
            ...state,
            productItems: state.productItems.setIn(
                [index, 'state'],
                state.productItems.getIn([index, 'state']).merge(fromJS(defaultMuting))
            )
        };
    }),
    [constants.TOGGLE_MONITORING_ALL_DONE]: handleReduce((state, { payload: { productId, isMonitoring } }) => {
        const index = getProductIndexById(state, productId);

        return {
            ...state,
            productItems: state.productItems.setIn([index, 'state', 'mute'], isMonitoring)
        };
    }),
    [constants.TOGGLE_MONITORING_SENSOR_DONE]: handleReduce(
        (state, { payload: { productId, isMonitoring, sensorType } }) => {
            const index = getProductIndexById(state, productId);

            return {
                ...state,
                productItems: state.productItems.setIn([index, 'state', 'sensors', sensorType], isMonitoring)
            };
        }
    )
};

const actionHandlers = {
    [constants.CHANGE_SENSE_LOGS_SELECTED_DAY]: handleReduce((state, { payload: { id, selectedDay } }: types.IdDay) =>
        state.withMutations(state =>
            state
                .setIn([id, selectedDay, 'loadError'], false)
                .setIn([id, selectedDay, 'hasLoaded'], false)
                .setIn([id, 'selectedDay'], selectedDay)
        )
    ),
    [constants.DELETE_SENSE_EVENT_COMPLETE]: handleReduce(
        (state, { payload: { id, mediaId } }: types.DeleteSenseEvent) => {
            const selectedDay = state.getIn([id, 'selectedDay']);
            const dayEvents = state.getIn([id, selectedDay, 'events']);
            const index = dayEvents.findIndex(log => log.get('media') === mediaId);

            return state.deleteIn([id, selectedDay, 'events', index]);
        }
    ),
    [constants.FLAG_SENSE_MEDIA_COMPLETE]: handleReduce(
        (state, { payload: { id, mediaId } }: types.FlagSenseMediaAction) => {
            const selectedDay = state.getIn([id, 'selectedDay']);
            const dayEvents = state.getIn([id, selectedDay, 'events']);
            const index = dayEvents.findIndex(log => log.get('media') === mediaId);

            return state.setIn([id, selectedDay, 'events', index, 'flagged'], true);
        }
    ),
    [constants.GET_SENSE_DAY_EVENT_LOGS]: handleReduce((state, { payload: { id, selectedDay } }: types.IdDay) =>
        state.setIn([id, selectedDay, 'hasLoaded'], false)
    ),
    [constants.RECEIVE_SENSE_DAY_EVENT_LOGS]: handleReduce(
        (state, { payload: { id, selectedDay, eventLogs } }: types.IdDayEvents) =>
            state.withMutations(state =>
                state.setIn([id, selectedDay, 'events'], eventLogs).setIn([id, selectedDay, 'hasLoaded'], true)
            )
    ),
    [constants.RECEIVED_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS]: handleReduce(
        (state, { payload: { status } }: types.SetHubOfflineNotificationsStatus) =>
            state.setIn(['hubOfflineNotifications', 'status'], status)
    )
};

export default handleActions(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/core/state/products/sense/index.js